import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router';
import styled from 'styled-components';

import { Navigate } from '@sorare/routing';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';

import { ImportLineup } from '#src/components/importLineup/ImportLineup/index.tsx';
import { useLastVisitedPlayTab } from '#src/hooks/useLastVisitedPlayTab.ts';

const Relative = styled.div`
  position: relative;
  isolation: isolate;
`;

const PlayProLayout = () => {
  useLastVisitedPlayTab({ tab: 'play' });
  const location = useLocation();

  // Fallback for old routes
  if (location.pathname.startsWith('/football/play/pro')) {
    const rest = location.pathname.replace(/^\/football\/play\/pro/, '');

    return (
      <Navigate to={`/football/play/classic${rest}`} replace keepSearchParams />
    );
  }

  return (
    <Relative>
      <Suspense fallback={<LoadingIndicator fullHeight />}>
        <Outlet />
        <ImportLineup />
      </Suspense>
    </Relative>
  );
};

export default PlayProLayout;
